import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { ParallaxBanner } from 'react-scroll-parallax';

const HeroSection = () => {
  // Static slide data (based on the original first slide, with updated text)
  const slide = {
    id: 1,
    bgImage: "/images/bg/detailing-home-slider-1-dark.jpg",
    tagline: "Expert Mobile Detailing at Your Doorstep",
    heading1: "Premium Care,",
    heading2: "Ultimate Convenience",
    services: [
      "Full Detailing",
      "Waterless Wash",
      "Ceramic Coatings",
      "Wheel Restoration"
    ],
    ctaText: "Get Your Free Quote"
  };

  return (
    <section className="slider-container relative overflow-hidden min-h-[80vh] md:min-h-[90vh]">
      {/* Adding test direct image tag to test image loading - can be removed if not needed */}
      <div className="hidden">
        <img src="/images/bg/detailing-home-slider-1-dark.jpg" alt="Test" />
        <img src="/images/hero-background.png" alt="Test hero" />
      </div>
      
      <ParallaxBanner
        layers={[{
          image: slide.bgImage,
          speed: -20, // Adjust speed for desired parallax intensity
        }]}
        className="embla__slide relative min-w-full min-h-[80vh] md:min-h-[90vh] flex items-center justify-center"
      >
        {/* Slide Overlay - now a direct child or sibling if needed, ensure it's on top of parallax bg */}
        <div className="absolute inset-0 bg-black/50 z-10" aria-hidden="true" />
        
        {/* Slide Content */}
        <div className="container mx-auto px-4 relative z-20 flex flex-col items-center justify-center py-8 pt-36">
          <div className="animate-fade-in-up text-center space-y-8">
            <div className="flex flex-col md:flex-row items-center md:items-start justify-center gap-8 animate-slide-in-top">
              <img 
                src="/images/logo/Detailing-Mascot-Character.png" 
                alt="Mobile Detail Co. Mascot Character" 
                className="mb-4 md:mb-0 w-40 md:w-56 drop-shadow-xl"
                style={{maxWidth: '260px', height: 'auto'}}
              />
              <div className="text-center md:text-left w-full">
                {/* Tagline */}
                <div>
                  <p className="font-bold text-white text-lg md:text-xl tracking-widest uppercase mb-4 drop-shadow-lg">
                    {slide.tagline}
                  </p>
                </div>
                {/* Main Headings */}
                <div>
                  <h2 className="text-4xl md:text-6xl font-extrabold text-white uppercase mb-4 drop-shadow-xl" style={{textShadow: '2px 4px 16px rgba(0,0,0,0.5), 0 1px 0 #fff'}}>
                    {slide.heading1}
                  </h2>
                </div>
                <div>
                  <h3 className="text-4xl md:text-6xl font-extrabold text-white uppercase mb-8 drop-shadow-xl" style={{textShadow: '2px 4px 16px rgba(0,0,0,0.5), 0 1px 0 #fff'}}>
                    {slide.heading2}
                  </h3>
                </div>
                {/* Services List */}
                <div className="animate-slide-in-bottom mt-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10 text-white font-bold">
                    {slide.services.map((service, index) => (
                      <div key={index} className="flex items-center gap-3 text-lg md:text-xl drop-shadow">
                        <CheckCircle className="h-6 w-6 text-primary" />
                        <span>{service}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4">
                    <Link to="/services" className="text-amber-400 text-xl flex items-center gap-2 justify-center font-bold drop-shadow">
                      <CheckCircle className="h-7 w-7 text-primary" />
                      <span>And many more!</span>
                    </Link>
                  </div>
                </div>
                {/* CTA Button */}
                <div className="animate-slide-in-up mt-8">
                  <Button 
                    size="lg" 
                    className="bg-primary hover:bg-primary/90 text-white px-8 py-6 text-lg uppercase font-bold shadow-xl"
                    asChild
                  >
                    <Link to="/quote">{slide.ctaText}</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ParallaxBanner>
      {/* Removed Slider Dots */}
    </section>
  );
};

export default HeroSection;
